import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import Swal from 'sweetalert2';
import { G_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Installment_View_Model';
import { G_Bulk_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Bulk_Installment_View_Model';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';
import { SaveGInstallmentRequest, SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { AppConsts } from 'src/app/common/app-consts';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
@Component({
  selector: 'app-direct-sale-list',
  templateUrl: './direct-sale-list.component.html',
  styleUrls: ['./direct-sale-list.component.scss']
})
export class DirectSaleListComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  public modalRef: BsModalRef;

  dataTable: any;
  @Input('dataTable') table;
  dtOption: any = {};
  public SortBy: string = "asc";
  myDate = new Date(Date.now());
  public component_Title = 'Direct Sale List';
  public itemVm: GVechileViewModel = new GVechileViewModel();
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmI: SaveGInstallmentRequest = new SaveGInstallmentRequest();
  public bulkInstallment: G_Bulk_Installment_View_Model = new G_Bulk_Installment_View_Model();
  public vmListItems: any = [];
  public attachmentList: any = [];
  public listOfAttachments: any = [];
  public goodResponse: any = [];
  public vmDirectList: any = [];
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;
  public customerDetail: any = null;
  public selectedcustomerDetail: any = null;
  public exportFormat: string = 'csv';
  startDate: any = null;
  endDate: any = null;
  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',  // The field to use for the selected ID
    textField: 'name',  // The field to use for displaying the customer name
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  public client: any;

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  isListVisible: boolean = false;

  @Output() onSubmitted = new EventEmitter<any>();
  constructor(
    private datePipe: DatePipe,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {

    this.client = this._localStorageService.get("com");
    this.getList();
    //this.getimage();
    // this.spinner.show();
    // this._uow.saleService.GetPagedDirectSale().subscribe((res: any) => {
    //   // this.vm = Object.assign({}, ...res);
    //   //   let response = Object.keys(res);
    //   //   let goodResponse = [];
    //   //   for ( let prop of response) {
    //   //     goodResponse.push(response[prop]);
    //   // }
    //   debugger
    //   this.vmDirectList = res.DtlList;
    //   this.vm = res.DtlList;
    //   this.listOfAttachments = this.vmDirectList
    //     .filter(record => record.AttachmentList && record.AttachmentList.length > 0) // Ensure AttachmentList exists and is not empty
    //     .flatMap(record => record.AttachmentList.map(attachment => ({ Id: record.Id, Name: attachment })));

    //   console.log(this.vm);
    //   // this._jq.showSpinner();
    //   this.spinner.hide();
    // }, (err) => {
    //   console.log(err);
    //   // this._jq.showSpinner();
    //   this.spinner.hide();
    //   Swal.fire(
    //     'Failure!',
    //     'Network Issue!',
    //     'error'
    //   )
    // });
  }

  // Method to toggle the visibility of the list
  toggleList() {
    this.isListVisible = !this.isListVisible;
  }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSaleService.getList("GSale", "GetDirectSalesAsync", this.p, this.size, search, this.orderBy, this.sort)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vm = res.result;
          this.vmDirectList = res.result;
          this.totalItems = res.total;

          this.listOfAttachments = this.vmDirectList
            .filter(record => record.attachmentList && record.attachmentList.length > 0) // Ensure AttachmentList exists and is not empty
            .flatMap(record => record.attachmentList.map(attachment => ({ id: record.id, Name: attachment })));
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
    this.isListVisible = false;
  }

  public clearOrder() {
    this.orderBy = 'Id';
    this.sort = 'Desc';
    this.getList();
    this.isListVisible = false;
  }

  // getimage() {
  //   this._uow.settingservice.GetByImage().subscribe((baseImage: any) => {
  //     console.log(baseImage);
  //     if (baseImage != undefined && baseImage !== null) {
  //       if (baseImage.Attachment != undefined && baseImage.Attachment !== null) {

  //         this.thumbnail = "https://garagedesks.s3.eu-central-1.amazonaws.com/" + baseImage.Attachment;
  //         this.ComName = baseImage.ComName;
  //         this.Address = baseImage.Address;
  //         this.contect = baseImage.contect;
  //       } else {
  //         this.thumbnail = baseImage.ComName;
  //         this.ComName = baseImage.ComName;
  //         this.Address = baseImage.Address;
  //         this.contect = baseImage.contect;
  //       }
  //     }

  //   }, (err) => {
  //     console.log(err);
  //   })
  // }
  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.vm = new SaveSaleMasterRequest();
      this.getList();
    } else {
      this._jq.showSpinner();
    }
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }


  openAttachmentHistoryModal(template: TemplateRef<any>, b) {
    debugger
    this.listOfAttachments = this.vmDirectList
      .filter(record => record.attachmentList && record.attachmentList.length > 0) // Ensure AttachmentList exists and is not empty
      .flatMap(record => record.attachmentList.map(attachment => ({ id: record.id, name: attachment })));
    this.listOfAttachments = this.listOfAttachments.filter(x => x.id === b);
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }

  openAttachmentModal(template: TemplateRef<any>, b) {
    debugger
    this._uow.gSaleService.GetGSaleByIdAsync(b).subscribe((res: any) => {
      this.attachmentList = res.attachmentList;
      console.log(this.attachmentList);
    });
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }

  openSModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-xl');
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openSModal(template);
    if (model !== undefined) {
      this.vm = model;
    } else {
      this.vm = new SaveSaleMasterRequest();
    }
  }

  openBulkPaymentModel(template: TemplateRef<any>, model?) {
    this.openSModal(template);
    if (model !== undefined) {
      this.bulkInstallment = model;
    }
  }

  public deleteId: string;
  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.vm = model;
      this.deleteId = model.uniqueId;
    }
  }

  openExportModel(template: TemplateRef<any>) {
    this.openModal(template);
    this.getCustomerName();
  }
  confirmDelete() {
    this.spinner.show();
    this._uow.gSaleService.DeleteGSaleAsync(this.deleteId).subscribe((res: any) => {
      this.ngOnInit();
      this.modalRef.hide();
      this.spinner.hide();
      Swal.fire(
        'Saved!',
        'Direct Sale Deletd!',
        'success'
      )
    }, (err) => {
      Swal.fire(
        'Saved!',
        'Direct Sale Not Deletd!',
        'error'
      );
      this.spinner.hide();
    });
  }


  getCustomerName() {
    debugger;
    this._uow.gSettingService.GetGCustomersDropDownAsync(AppConsts.CUSTOMER).subscribe(
      (res: any) => {
        debugger;
        this.customerDetail = res.result.map(x => {
          return {
            id: x.id, // or the actual ID field
            name: x.accCode + '-' + x.accTitle // concatenated name and code
          };
        });

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }

  exportToExcel() {
    debugger;
    this.spinner.show();
    // var obj = new ExportExcel();
    // obj = {

    //   StartDate: this.startDate,
    //   EndDate: this.endDate,
    //   Format: this.exportFormat
    // }
    var CustomerId = this.selectedcustomerDetail && this.selectedcustomerDetail.length > 0
      ? this.selectedcustomerDetail[0].id
      : 0;

    this._uow.gSaleService.GetAllSaleOrdersExportAsync(CustomerId, this.startDate, this.endDate, 8).subscribe((res: any) => {
      debugger;
      this.openLinkInNewTab(res.file);
      this.spinner.hide();
      this.modalRef.hide();
    },
      (error) => {
        debugger
        this._uow.logger.log(error);
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
      });
  }

  openLinkInNewTab(url) {
    window.open(url, '_blank');
  }

  // getCustomerName() {
  //   debugger;
  //   this._uow.customerService.GetList().subscribe(
  //     (res: any) => {
  //       debugger;
  //       this.customerDetail = res.DtlList.map(x => {
  //         return {
  //           id: x.Id, // or the actual ID field
  //           name: x.Acc_Code + '-' + x.Acc_Titel // concatenated name and code
  //         };
  //       });

  //       // this.itemVm.RegistraionNumber = res;
  //       console.log(res);
  //       this._jq.showSpinner();
  //       // this.itemVm.RegistraionNumber = res.code;
  //     },
  //     (error) => {
  //       this._uow.logger.log(error);
  //       this._jq.showSpinner();
  //     }
  //   );
  // }
  // exportToExcel() {
  //   debugger;
  //   this.spinner.show();
  //   var obj = new ExportExcel();
  //   obj = {
  //     Customer_Id: this.selectedcustomerDetail && this.selectedcustomerDetail.length > 0
  //       ? this.selectedcustomerDetail[0].id
  //       : null,  // Assign null if selectedcustomerDetail is null or empty
  //     StartDate: this.startDate,
  //     EndDate: this.endDate,
  //     Format: this.exportFormat
  //   }
  //   this._uow.saleService.ExportDirectSale(obj).subscribe((res: any) => {
  //     debugger;

  //     const blob = new Blob([res], { type: res.type });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `SalesData_${new Date().toISOString().split('T')[0]}.${this.exportFormat.toLowerCase()}`;
  //     document.body.appendChild(a);
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);

  //     this.spinner.hide();
  //     this.modalRef.hide();
  //   },
  //     (error) => {
  //       this._uow.logger.log(error);
  //       this.spinner.hide();
  //       Swal.fire(
  //         'Failure!',
  //         'Network Issue!',
  //         'error'
  //       )
  //     });
  // }
}
